<div class="ph-avatar" [ngClass]="{ loading: loading }" *ngIf="!loading">
  <ngx-avatars
    [size]="size"
    [name]="username"
    [bgColor]="isWhite ? '#FFFFFF00' : null"
    [fgColor]="'#FFFFFF'"
    [borderColor]="isWhite ? '#FFFFFF' : null"
    [src]="currentSrc"
  ></ngx-avatars>
</div>
